import Style from './ResetPassword.module.scss'
import { $t } from '../../../helpers/translator';
import { useState, useEffect } from 'react';
import api from '../../../helpers/api';
import Logo from '../../../assets/logo.svg'
import BottomDecoration from '../../../assets/bottom_decoration.svg'
import { useHistory } from 'react-router-dom';

const ResetPassword = (props) => {
    const history = useHistory();

    const { id, token } = props.match.params;
    const [ loading, setLoading ] = useState(true);
    const [ success, setSuccess ] = useState(null);
    const [ valid, setValid ] = useState(null);
    const [ password, setPassword ] = useState(null);
    const [ passwordConfirm, setPasswordConfirm ] = useState(null);

    useEffect(() => {
        resetPassword().then((res) => {
            setValid(res.success);
        }).catch((e) => {
            setValid(false);
        }).finally(() => {
            setLoading(false);
        })
    }, [])

    useEffect(() => {
        if(valid !== null) {
            if(!valid) {
                history.push('/login');
            }
        }
    }, [valid])

    const doResetPassword = () => {
        if (password === passwordConfirm) {
            if (password.length >= 6) {
                setLoading(true);
                setSuccess(null);

                resetPassword().then((res) => {
                    setSuccess(res.data.success);
                    if (res.success === true) {
                        sleep(5000).then(() => {
                            window.location = '/login';
                        })
                    }
                }).catch((e) => {
                    setSuccess(false);
                }).finally(() => {
                    setLoading(false);
                });
            } else {
                alert($t('global.register.errors.WRONG_PASSWORD_LENGTH'))
            }
        } else {
            alert($t('global.resetPassword.errorNoMatch'));
        }
    }

    const resetPassword = async () => {
        const payload = password !== null ? {
            id: id,
            token: token,
            password: password
        } : {
            id: id,
            token: token
        };

        return await api.post('/auth/forgot/password/reset', payload);
    }

    const sleep = (ms) => {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    return (
        <div className={ Style[ 'pageContainer' ] }>
            <div className={ Style[ 'container' ] }>
                <div className={ success === null ? Style[ 'alert' ] : (success === true ? [ Style[ 'alert' ], Style[ 'alert-success' ] ].join(' ') : [ Style[ 'alert' ], Style[ 'alert-error' ] ].join(' ')) } style={ { transition: '0.2s all', opacity: success === null ? 0 : 1 } }>
                    { success === true && $t('global.resetPassword.success') }
                    { success === false && $t('global.resetPassword.error') }
                    <a href='#' style={ { color: 'white', float: 'right' } } onClick={ (e) => {
                        e.preventDefault();
                        setSuccess(null);
                    } }>×</a>
                </div>
                <div className={ Style[ 'page' ] }>
                    <div className={ loading ? [ Style[ "loader" ], Style[ "loader-show" ] ].join(' ') : Style[ "loader" ] }>
                        <svg version="1.1" id="loader-1" x="0px" y="0px"
                            width="40px" height="40px" viewBox="0 0 40 40" enable-background="new 0 0 40 40" >
                            <path opacity="0.2" fill="#000" d="M20.201,5.169c-8.254,0-14.946,6.692-14.946,14.946c0,8.255,6.692,14.946,14.946,14.946
                                    s14.946-6.691,14.946-14.946C35.146,11.861,28.455,5.169,20.201,5.169z M20.201,31.749c-6.425,0-11.634-5.208-11.634-11.634
                                    c0-6.425,5.209-11.634,11.634-11.634c6.425,0,11.633,5.209,11.633,11.634C31.834,26.541,26.626,31.749,20.201,31.749z"/>
                            <path fill="#000" d="M26.013,10.047l1.654-2.866c-2.198-1.272-4.743-2.012-7.466-2.012h0v3.312h0
                                        C22.32,8.481,24.301,9.057,26.013,10.047z">
                                <animateTransform attributeType="xml"
                                    attributeName="transform"
                                    type="rotate"
                                    from="0 20 20"
                                    to="360 20 20"
                                    dur="0.5s"
                                    repeatCount="indefinite" />
                            </path>
                        </svg>
                    </div>
                    <form onSubmit={ (e) => { e.preventDefault(); doResetPassword() } } className={ Style[ 'pageContent' ] }>
                        { valid === true ? <>
                            { success === true && <div className={ [ Style[ "loader" ], Style[ "loader-show" ] ].join(' ') }>
                                { $t('global.resetPassword.redirect') }
                            </div> }
                            <div className={ Style[ "side-bar" ] }>
                                <img src={Logo} className={ Style[ "logo" ] } alt="Alma lasers" />
                                <img src={BottomDecoration} alt="" className={ Style[ "decoration" ] } />
                            </div>
                            <div className={ Style[ 'pageContentForm' ] }>
                                <div>
                                    <h1 className={ Style[ 'title' ] }>{ $t('global.resetPassword.title') }</h1>
                                    <p className={ Style[ 'text-muted' ] }>{ $t('global.resetPassword.description') }</p>
                                </div>
                                <div>
                                    <label>{ $t('global.resetPassword.input.password.label') }</label>
                                    <input onChange={ (e) => {
                                        setPassword(e.target.value);
                                    } } className={ Style[ 'form-control' ] } name='password' placeholder={ $t('global.resetPassword.input.password.placeholder') } type='password' required />
                                </div>
                                <div>
                                    <label>{ $t('global.resetPassword.input.passwordConfirm.label') }</label>
                                    <input onChange={ (e) => {
                                        setPasswordConfirm(e.target.value);
                                    } } className={ Style[ 'form-control' ] } name='password_confirm' placeholder={ $t('global.resetPassword.input.passwordConfirm.placeholder') } type='password' required />
                                </div>
                                <div>
                                    <button type="submit" className={ `${Style[ 'btn' ]} ${Style[ 'btn-primary' ]}` }>{ $t('global.resetPassword.input.submit') }</button>
                                </div>
                            </div>
                        </> : <></> }
                    </form>
                </div>
            </div>
        </div>
    )

}

export default ResetPassword;